import { persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface AppStore {
  /** Epoch time after which to show the match auto banner */
  autoBannerDismissedUntil: number;
  /** Set the epoch time after which to show the matcha auto banner */
  setAutoBannerDismissedUntil: (date: number) => void;
}

export const useAppStore = createWithEqualityFn<AppStore>()(
  persist(
    (set) => ({
      autoBannerDismissedUntil: new Date().getTime(),
      setAutoBannerDismissedUntil: (autoBannerDismissedUntil: number) =>
        set({ autoBannerDismissedUntil }),
    }),
    {
      name: 'app-store',
      partialize: (state) => ({
        autoBannerDismissedUntil: state.autoBannerDismissedUntil,
      }),
    },
  ),
  shallow,
);

export const autoBannerSelectors = ({
  autoBannerDismissedUntil,
  setAutoBannerDismissedUntil,
}: AppStore) => ({
  autoBannerDismissedUntil,
  setAutoBannerDismissedUntil,
});
